module.exports = __webpack_public_path__ + "resources/img/img_tibero4.bf5f22249cbd33cd1e313aa948e60723.png";